import 'slick-carousel/slick/slick'


export default class HeroSlider {
	
	constructor() {
		
		this.settings = {
			$slider : $('.js-hero-slider')
		};
		
		this.bindUIActions();
		
	}
	
	bindUIActions() {

		if(this.settings.$slider.length) {

			if ($(window).width() > 1023) {
				let headerHeight = $('.header').height();
				$('.js-hero-slide').css('height', 'calc(100vh - ' + headerHeight + 'px)');
			}
			
			this.settings.$slider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				autoplay: true,
				autoplaySpeed: 5000,
				speed: 500,
			});
			
		}
		
	}

};

new HeroSlider();